import { Component, OnInit, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { AppComponent } from '../app.component';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./modal.component.less']
})
export class ModalComponent implements OnInit {
  modalInfo: any;
  timeToClose: number = 5;
  interval: any;

  constructor(
    public app: AppComponent,
  ) { }

  ev: any;

  ngOnInit() {
    this.app.sharedToolsService.getJSON('txtModals').subscribe(resp => {
      console.log("resp ==> ", resp.data);

      this.app.confirmDialogService.getModalInfo().subscribe(modalInfo => {
        this.modalInfo = modalInfo;
        console.log("this.modalInfo ==> ", this.modalInfo);

        this.app.dataToolsService.setmodalInfo(this.modalInfo);

        // ==> Modal loader estimation se ferme en x segondes (timeToClose)
        if (this.modalInfo && this.modalInfo.template) {
          if (this.modalInfo.template == 'modal-loader-estimation') {

            let modalData = JSON.parse(localStorage.getItem('modalOpen')!);

            let pathBtnSuivant = (modalData && modalData.pathBtnSuivant) ? modalData.pathBtnSuivant : "";

            this.interval = setInterval(() => {
              if (this.timeToClose > 0) {
                this.timeToClose--;
              } else {
                // ==> On Close la modal

                // ==> On redirect PROBLEME. Quand je suis sur estimation et que je click sur le bouton du nav pour aller en arriere, il redirect encore sur estimation
                //if (this.timeToClose == 0) this.app.sharedToolsService.goTo(pathBtnSuivant, null);
                clearInterval(this.interval);
                if (this.modalInfo && this.modalInfo.template) this.modalInfo.noFn();
                localStorage.setItem('modalInfo', JSON.stringify(this.modalInfo));
                this.app.sharedToolsService.goTo(pathBtnSuivant, null);
              }
            }, 1005)
          }
        }
      });
    })
  }

  styleModal(type: string): Object {
    if (type == 'confirm') {
      return { width: '400px' }
    }
    if (type == 'alert') {
      return { width: '300px' }
    }
    return {}
  }

  styleModalContent(type: string): Object {
    if (type == 'alert') {
      return { height: 'auto' }
    }
    return {}
  }

}
